// eslint-disable-next-line import/no-extraneous-dependencies
import mixpanel from "mixpanel-browser";

mixpanel.init('37f09c2617172fda4282cdf27073b895', { debug: false });

export default mixpanel